// extracted by mini-css-extract-plugin
export default {"button":"CustomPopoverCheckbox_button__1VzQN","buttonInfo":"CustomPopoverCheckbox_buttonInfo__IEhzV"};